// external
import { useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import { ToastContainer, toast } from "react-toastify";

// components
import StepNavigation from "components/StepNavigation";
import FaoBuilderHeader from "./fao-layout/fao-builder-header";
import ProgressTracker from "components/ProgressTracker";
import ModelCard from "components/ModelCard";
import Textarea from "../../components/partials/textarea/textarea";
// api
import apiRoot from "../../api/apiRoot";

// state managing/security
import { FaoBuilderContext } from "context/FaoBuilderContext";

// constants
import { STEPS } from "./constants/faob-steps.constants";

function FaoCheckout() {
  const { modelConfig } = useContext(FaoBuilderContext);
  const [isPublished, setIsPublished] = useState(false);
  const [description, setDescription] = useState(modelConfig.description || "");
  const navigate = useNavigate();
  const areConfigsComplete = () => {
    // check if model metadata is cmoplete
    const isMetadataComplete =
      modelConfig.versionName &&
      modelConfig.studentType &&
      modelConfig.entryTerm &&
      modelConfig.authorName;
    const incompleteConfigs = STEPS.filter((item) => item.value).filter(
      (item) => !modelConfig.configs[item.value]
    );
    return incompleteConfigs.length === 0 && isMetadataComplete;
  };
  const handlePublish = async () => {
    console.log(isPublished);
    try {
      const configCheck = areConfigsComplete();
      // show an error message if all steps are not complete
      if (!configCheck) {
        toast.error("Please complete all steps before publishing the model");
        return;
      }
      if (!description) {
        toast.error("Please enter a description for this model");
        return;
      }
      // if model is already published, lead the user to the page with all published models
      if (isPublished) {
        navigate(`../fao-builder/fao-edit`);
        return;
      }
      // flip the status to published for the current model
      const publishedModel = {
        ...modelConfig,
        status: "published",
        description: description,
      };
      const toastMessages = {
        pending: "Publishing Model",
        success: "SUCCESS - Model Published",
        error: "ERROR - Please reach out to support for assistance",
      };
      const promise = apiRoot.patch(
        `/api/fao-model/${modelConfig.id}`,
        publishedModel
      );
      await toast.promise(promise, toastMessages);
      setIsPublished(true);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div>
      <ToastContainer />
      <FaoBuilderHeader
        modelName={modelConfig.versionName}
        modelId={modelConfig.id}
      />
      <ProgressTracker currentStep={10} />
      <ModelCard
        model={modelConfig}
        disabled={true}
        isPublished={isPublished}
      />
      <Textarea
        placeholder="Enter a description for this model"
        limit={500}
        value={description}
        onChange={setDescription}
        required={true}
        textareaStyles="mt-3 block w-full rounded-md border-gray-300 shadow-sm"
      />
      <StepNavigation
        onClickBack={() =>
          navigate(`../fao-builder/${modelConfig?.id}/awarding-strategy`)
        }
        onClickNext={handlePublish}
        isSaved={isPublished}
        isCheckout={true}
      />
    </div>
  );
}

export default FaoCheckout;
